<template>
  <div>
  </div>
</template>

<script>
import Session from '@/client/session'

export default {
  name: 'ConfirmView',

  props: {},

  data () {
    return {
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
  },

  watch: {
  },

  async mounted () {
    try {
      await Session.confirmEmail(this.$route.query.confirmation_token)
      this.setNotification({ color: 'success', message: this.$t('emailConfirmed') })
    } catch (err) {
      this.handleErr(err)
    }
    this.goTo('login')
  }
}
</script>
